import script from "./inputTextDataList.vue?vue&type=script&setup=true&lang=js"
export * from "./inputTextDataList.vue?vue&type=script&setup=true&lang=js"

import "./inputTextDataList.vue?vue&type=style&index=0&id=d80662c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d80662c2"]])

export default __exports__